import { useState, type ReactNode } from 'react';

type AlertVariant = 'success' | 'warning' | 'error' | 'info';

interface GabAlertProps {
  children: ReactNode;
  variant?: AlertVariant;
  dismissible?: boolean;
  className?: string;
}

export function GabAlert({ children, variant = 'info', dismissible, className = '' }: GabAlertProps) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className={`alert alert-${variant} ${className}`} role="alert">
      <div style={{ flex: 1 }}>{children}</div>
      {dismissible && (
        <button className="alert-dismiss" onClick={() => setVisible(false)} aria-label="Dismiss">&times;</button>
      )}
    </div>
  );
}
